export default "__VITE_ASSET__rRMRWfUO__"